<template>
  <v-card data-testid="regimen_grid_set_edit">
    <v-card-text>
      <v-alert v-if="!localValue.grid_set" type="error" outlined dense>
        {{ $t("regimen_container_edit.snapshot_missing") }}
      </v-alert>
      <template v-else>
        <v-layout row wrap>
          <v-flex xs12 md8 class="pr-md-6">
            <h3 class="mb-3">{{ localValue.grid_set.title }}</h3>
            <p v-if="localValue.grid_set.description">{{ localValue.grid_set.description }}</p>
          </v-flex>
          <v-flex xs12 md4>
            <RegimenGridCustomizationPanel
              :status="customization_status"
              :can-update-from-source="can_update_from_source"
              @customize="grid_set_edit_dialog = true"
              @update-from-source="update_from_source"
            />
          </v-flex>
        </v-layout>
        <ExerciseListEdit
          class="mt-6"
          :value="localValue.grid_set.exercises"
          readonly
          :show_add_actions="false"
        />
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!localValue.grid_set"
        data-testid="regimen_grid_set_edit_save"
        @click="$emit('save')"
      >
        {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>

    <v-dialog v-model="grid_set_edit_dialog" max-width="1200" :fullscreen="small_screen || phone_screen">
      <GridSetEdit
        v-if="grid_set_edit_dialog"
        :existing_set="localValue.grid_set"
        :clinic_id="clinic_id"
        @close="grid_set_edit_dialog = false"
        @grid-set-updated="grid_set_updated"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import ExerciseListEdit from "./ExerciseListEdit.vue";
import GridSetEdit from "./GridSetEdit.vue";
import RegimenGridCustomizationPanel from "./RegimenGridCustomizationPanel.vue";
import {
  cloneSourceOntoAssignment,
  gridCustomizationStatus,
  resolveSourceGrid,
} from "../lib/regimen_grid_customization";

export default {
  components: { ExerciseListEdit, GridSetEdit, RegimenGridCustomizationPanel },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      grid_set_edit_dialog: false,
    };
  },
  computed: {
    ...mapState(["current_clinic_id", "grid_sets", "small_screen", "phone_screen"]),
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    clinic_id() {
      return (this.localValue.grid_set && this.localValue.grid_set.clinic_id)
        || this.current_clinic_id
        || "";
    },
    source_grid() {
      return resolveSourceGrid(this.localValue, { grid_sets: this.grid_sets });
    },
    customization_status() {
      return gridCustomizationStatus(this.localValue, this.source_grid);
    },
    can_update_from_source() {
      return Boolean(
        this.source_grid
        && (this.customization_status === "customized" || this.customization_status === "out_of_date"),
      );
    },
  },
  methods: {
    grid_set_updated(updatedSet) {
      Vue.set(this.localValue, "grid_set", JSON.parse(JSON.stringify(updatedSet)));
      Vue.set(this.localValue, "grid_customized", true);
      this.grid_set_edit_dialog = false;
    },
    update_from_source() {
      if (!this.source_grid) return;
      cloneSourceOntoAssignment(this.localValue, this.source_grid);
      Vue.set(this.localValue, "grid_set", this.localValue.grid_set);
      Vue.set(this.localValue, "grid_customized", false);
    },
  },
};
</script>
